// Code generated from libs/omniwound/auth-contract/operations/interactive-operations-v1.json. DO NOT EDIT.
// Run `pnpm generate:omniwound-auth-contract` after changing the manifest.

export const OPERATION_REGISTRY_VERSION = 1 as const;

export const AUTHORIZATION_CORRELATION_METADATA = {
  "executionIdKey": "x-correlation-id",
  "decisionIdKey": "x-authorization-decision-id"
} as const;

/**
 * The per-leg declaration that a downstream leg authorizes against the
 * target its action already resolved, instead of deriving one from its own
 * payload. Emitted here so the TypeScript producer imports the value the
 * manifest validated rather than restating it (ADR 0307).
 */
export const DOWNSTREAM_TARGET_SOURCE_ACTION = "action" as const;

/**
 * The inbound request-metadata key a caller uses to supply a mutation's
 * stable intent id. Frozen wire format: it appears in stored authorization
 * evidence, so a change is a migration, never a rename (ADR 0273).
 */
export const AUTHORIZATION_INTENT_METADATA = {
  "intentIdKey": "x-omniwound-authorization-intent-id"
} as const;

/**
 * Whether an interactive operation creates a downstream effect. A mutation
 * must receive its intent id from the caller; a read-only operation may use
 * an ingress-generated one (ADR 0273).
 */
export const INTERACTIVE_OPERATION_EFFECTS = {
  MUTATION: 'mutation',
  READ_ONLY: 'read-only',
} as const;

export type InteractiveOperationEffect =
  (typeof INTERACTIVE_OPERATION_EFFECTS)[keyof typeof INTERACTIVE_OPERATION_EFFECTS];

export const POLICY_COVERAGE_REGISTRY = {
  "coreReceiptProtectedHandlers": [
    "AddPayorCommand",
    "ApproveQAReviewCommand",
    "AssignQAReviewCommand",
    "CancelAppointmentCommand",
    "CancelVisitCommand",
    "CheckDuplicatePatientQuery",
    "CompleteWoundImageUploadCommand",
    "CoordinateAccountLifecycleCommand",
    "CorrectEncounterTimingCommand",
    "CreateIntakePatientCommand",
    "CreatePatientCommand",
    "EnsureReferralServiceLocationCommand",
    "GetCorrectionDifferenceQuery",
    "GetCorrectionPreviewQuery",
    "GetMedicalHistoryQuery",
    "GetMedicalHistoryTemplatesQuery",
    "GetPatientCensusStatsQuery",
    "GetPatientDocumentsQuery",
    "GetPatientQuery",
    "GetProgressNoteArtifactContentQuery",
    "GetProgressNoteArtifactQuery",
    "GetProgressNoteQuery",
    "GetQAReviewQuery",
    "GetReferralQuery",
    "GetReferralReadinessQuery",
    "GetSignedWoundImageMediaContentQuery",
    "GetSkinExamCatalogQuery",
    "GrantStaffAccessAssignmentCommand",
    "ListAppointmentAvailabilityQuery",
    "ListAppointmentsQuery",
    "ListCensusPatientsQuery",
    "ListCoveragesQuery",
    "ListFieldTemplatesQuery",
    "ListNoteOriginatedBookingReconciliationQuery",
    "ListOrgFieldTemplateCountsQuery",
    "ListOrgFieldTemplatesQuery",
    "ListOrganizationsQuery",
    "ListPatientProgressNotesQuery",
    "ListPayorOrganizationsQuery",
    "ListProgressNoteNextVisitAvailabilityQuery",
    "ListProgressNotesQuery",
    "ListProvidersQuery",
    "ListQAReviewsQuery",
    "ListReferralsQuery",
    "ListSkinExamEtiologyOptionsQuery",
    "ListSkinExamLocationsQuery",
    "ListStaffAccessAssignmentsQuery",
    "ListVisitsQuery",
    "MarkVisitMissedCommand",
    "PrepareAmendmentReviewCommand",
    "PrepareCleanQAApprovalCommand",
    "PrepareProgressNoteSigningReviewCommand",
    "PrepareWoundImageTerminalReleaseCommand",
    "PreviewGrantStaffAccessAssignmentQuery",
    "PreviewWoundImageQuery",
    "ProvisionProviderAccountCommand",
    "RecordAuditEventCommand",
    "RecordVisitAttendanceOutcomeCommand",
    "RescheduleAppointmentCommand",
    "RescheduleMissedAppointmentCommand",
    "ReserveWoundImageUploadCommand",
    "ResolvePractitionerDisplayNamesQuery",
    "RestoreWoundImageReleaseCommand",
    "ReviewAndFinalizeCorrectionCommand",
    "SaveAmendmentStepCommand",
    "SaveFieldTemplatesCommand",
    "SaveOrgFieldTemplatesCommand",
    "SaveProgressNoteNextVisitCommand",
    "SaveProgressNoteStepCommand",
    "ScheduleAppointmentCommand",
    "SignProgressNoteCommand",
    "StartAppointmentEncounterCommand",
    "StartCorrectionCommand",
    "StartOrResumeProgressNoteCommand",
    "TakeoverQAReviewCommand",
    "UpdateAppointmentCommand",
    "UpdateCoveragesCommand",
    "UpdateMedicalHistoryCommand",
    "UpdateMedicalHistoryTemplatesCommand",
    "UpdatePatientCommand",
    "UpdateReferralCommand",
    "UpdateVisitCommand",
    "UploadWoundImageBytesCommand"
  ],
  "directGenericCalls": [
    "care-dispatcher/*generated*",
    "fhir-server/*generated*",
    "geocoder/GET/search",
    "object-storage/PresignGetObject"
  ],
  "asyncAdmissions": [
    "CoordinateAccountLifecycleCommand",
    "ProvisionProviderAccountCommand",
    "UpdatePatientCommand"
  ],
  "workloadOperations": [
    "GET /api/v1/internal/keycloak/human-authority-subject",
    "GET /api/v1/internal/keycloak/human-authority-subjects",
    "POST /api/v1/internal/keycloak/disable",
    "POST /api/v1/internal/keycloak/offboard",
    "POST /api/v1/internal/keycloak/practitioner-link/commit",
    "POST /api/v1/internal/keycloak/practitioner-link/validate",
    "POST /api/v1/internal/keycloak/provision",
    "POST /api/v1/internal/keycloak/reactivate",
    "POST /api/v1/internal/keycloak/reactivate/validate",
    "POST /api/v1/internal/keycloak/realm-role",
    "POST /api/v1/internal/keycloak/sessions/revoke",
    "cqrs-command:RegisterBootstrapAdministratorCommand",
    "cqrs-query:GetAuthorityReadinessQuery",
    "cqrs-query:GetAuthoritySnapshotQuery",
    "go-invoke:appwoundimages.RegisterWoundImageCleanupWorker",
    "go-invoke:audithandlers.RegisterOutboxReconciler",
    "go-invoke:qahandlers.RegisterRoutingOutboxReconciler",
    "go-invoke:securityaccess.RegisterAuthorityNotificationReconciler",
    "go-invoke:securityaccess.RegisterNonceArchiveReconciler",
    "go-provider:infraqa.NewAmendmentRoutingDispatcher"
  ]
} as const;

export const REGISTERED_WORKLOAD_OPERATION_REGISTRY = [
  {
    "operationId": "omniwound.workload.admin-bff.provision-account",
    "discoveryKey": "POST /api/v1/internal/keycloak/provision",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/provision",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.change-realm-role",
    "discoveryKey": "POST /api/v1/internal/keycloak/realm-role",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/realm-role",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.offboard-account",
    "discoveryKey": "POST /api/v1/internal/keycloak/offboard",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/offboard",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.revoke-sessions",
    "discoveryKey": "POST /api/v1/internal/keycloak/sessions/revoke",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/sessions/revoke",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.validate-practitioner-link",
    "discoveryKey": "POST /api/v1/internal/keycloak/practitioner-link/validate",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/practitioner-link/validate",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.commit-practitioner-link",
    "discoveryKey": "POST /api/v1/internal/keycloak/practitioner-link/commit",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/practitioner-link/commit",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.validate-reactivation",
    "discoveryKey": "POST /api/v1/internal/keycloak/reactivate/validate",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/reactivate/validate",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.reactivate-account",
    "discoveryKey": "POST /api/v1/internal/keycloak/reactivate",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/reactivate",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.disable-account",
    "discoveryKey": "POST /api/v1/internal/keycloak/disable",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "POST /api/v1/internal/keycloak/disable",
    "localIntegrityGuard": "exact-service-principal-jwt-and-caller-method-acl",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.list-human-authority-subjects",
    "discoveryKey": "GET /api/v1/internal/keycloak/human-authority-subjects",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "GET /api/v1/internal/keycloak/human-authority-subjects",
    "localIntegrityGuard": "exact-service-principal-jwt-and-revision-bound-snapshot",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.admin-bff.get-human-authority-subject",
    "discoveryKey": "GET /api/v1/internal/keycloak/human-authority-subject",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-admin-bff",
    "service": "omniwound-admin-bff",
    "method": "GET /api/v1/internal/keycloak/human-authority-subject",
    "localIntegrityGuard": "exact-service-principal-jwt-and-non-enumerable-subject-match",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "synchronous"
  },
  {
    "operationId": "omniwound.workload.audit-outbox-reconciliation",
    "discoveryKey": "go-invoke:audithandlers.RegisterOutboxReconciler",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "audit.OutboxReconciler.Run",
    "localIntegrityGuard": "audit-outbox-claim-and-fhir-transaction",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  },
  {
    "operationId": "omniwound.workload.authority-notification-reconciliation",
    "discoveryKey": "go-invoke:securityaccess.RegisterAuthorityNotificationReconciler",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "security.access.AuthorityNotificationReconciler.Run",
    "localIntegrityGuard": "authority-notification-outbox-claim",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  },
  {
    "operationId": "omniwound.workload.assertion-nonce-archive",
    "discoveryKey": "go-invoke:securityaccess.RegisterNonceArchiveReconciler",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "security.access.NonceArchiveReconciler.Run",
    "localIntegrityGuard": "assertion-nonce-archive-claim",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  },
  {
    "operationId": "omniwound.workload.read-authority-snapshot",
    "discoveryKey": "cqrs-query:GetAuthoritySnapshotQuery",
    "callerWorkload": "policy-governance",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "GetAuthoritySnapshotQuery",
    "localIntegrityGuard": "repeatable-read-authority-revision-and-semantic-digest",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-1-synchronous-workload"
  },
  {
    "operationId": "omniwound.workload.read-authority-readiness",
    "discoveryKey": "cqrs-query:GetAuthorityReadinessQuery",
    "callerWorkload": "policy-governance",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "GetAuthorityReadinessQuery",
    "localIntegrityGuard": "trusted-tenant-continuity-and-bounded-ledger-probe",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-1-synchronous-workload"
  },
  {
    "operationId": "omniwound.workload.admin-bff.register-bootstrap-administrator",
    "discoveryKey": "cqrs-command:RegisterBootstrapAdministratorCommand",
    "callerWorkload": "omniwound-admin-bff",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "RegisterBootstrapAdministratorCommand",
    "localIntegrityGuard": "bootstrap-token-constant-time-digest-durable-rate-limit-and-singleton-reservation",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-1-synchronous-workload"
  },
  {
    "operationId": "omniwound.workload.qa-routing-outbox-reconciliation",
    "discoveryKey": "go-invoke:qahandlers.RegisterRoutingOutboxReconciler",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "qa.RoutingOutboxReconciler.Run",
    "localIntegrityGuard": "qa-routing-commit-evidence-and-outbox-claim",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  },
  {
    "operationId": "omniwound.workload.wound-image-cleanup",
    "discoveryKey": "go-invoke:appwoundimages.RegisterWoundImageCleanupWorker",
    "callerWorkload": "omniwound-core",
    "audience": "omniwound-core",
    "service": "omniwound-core",
    "method": "woundimages.WoundImageCleanupWorker.Run",
    "localIntegrityGuard": "authoritative-cleanup-ownership-proof",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  },
  {
    "operationId": "omniwound.workload.qa-amendment-routing-dispatch",
    "discoveryKey": "go-provider:infraqa.NewAmendmentRoutingDispatcher",
    "callerWorkload": "omniwound-core",
    "audience": "temporal",
    "service": "temporal",
    "method": "AmendmentRoutingWorkflow",
    "localIntegrityGuard": "signed-revision-commit-and-idempotent-workflow-id",
    "authorityMode": "registered-no-human-workload",
    "asyncClass": "class-3-workload"
  }
] as const;

export type RegisteredWorkloadOperation = (typeof REGISTERED_WORKLOAD_OPERATION_REGISTRY)[number];
export type RegisteredWorkloadOperationId = RegisteredWorkloadOperation['operationId'];

export function registeredWorkloadOperation(operationId: RegisteredWorkloadOperationId): RegisteredWorkloadOperation {
  const operation = REGISTERED_WORKLOAD_OPERATION_REGISTRY.find((candidate) => candidate.operationId === operationId);
  if (!operation) throw new Error(`Unregistered workload operation: ${operationId}`);
  return operation;
}

export const INTERACTIVE_OPERATION_REGISTRY = [
  {
    "id": "omniwound.clinician.get-application-access",
    "surface": "clinician",
    "route": "getApplicationAccess",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListStaffAccessAssignmentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListStaffAccessAssignmentsQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "access.getApplicationAccess",
      "selectors": [
        {
          "path": "targetKeycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-application-access",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-provider-capabilities",
    "surface": "clinician",
    "route": "getProviderCapabilities",
    "downstreamMethods": [],
    "target": {
      "extractorId": "access.getProviderCapabilities",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-provider-capabilities",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "not-applicable",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-appointments",
    "surface": "clinician",
    "route": "listAppointments",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListAppointmentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListAppointmentsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.listAppointments",
      "selectors": [
        {
          "path": "providerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-appointments",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-appointment-availability",
    "surface": "clinician",
    "route": "listAppointmentAvailability",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListAppointmentAvailabilityQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListAppointmentAvailabilityQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.listAppointmentAvailability",
      "selectors": [
        {
          "path": "providerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-appointment-availability",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.schedule-appointment",
    "surface": "clinician",
    "route": "scheduleAppointment",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ScheduleAppointmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.ScheduleAppointmentCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.scheduleAppointment",
      "selectors": [
        {
          "path": "providerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.schedule-appointment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.reschedule-appointment",
    "surface": "clinician",
    "route": "rescheduleAppointment",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "RescheduleAppointmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RescheduleAppointmentCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.rescheduleAppointment",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.reschedule-appointment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.reschedule-missed-appointment",
    "surface": "clinician",
    "route": "rescheduleMissedAppointment",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "RescheduleMissedAppointmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RescheduleMissedAppointmentCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.rescheduleMissedAppointment",
      "selectors": [
        {
          "path": "providerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.reschedule-missed-appointment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-appointment",
    "surface": "clinician",
    "route": "updateAppointment",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateAppointmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateAppointmentCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.updateAppointment",
      "selectors": [
        {
          "path": "providerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-appointment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.cancel-appointment",
    "surface": "clinician",
    "route": "cancelAppointment",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CancelAppointmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CancelAppointmentCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.cancelAppointment",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.cancel-appointment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.mark-visit-missed",
    "surface": "clinician",
    "route": "markVisitMissed",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "MarkVisitMissedCommand",
        "requestProtoFullName": "api.v1.omniwound_core.MarkVisitMissedCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.markVisitMissed",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.mark-visit-missed",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.start-appointment-encounter",
    "surface": "clinician",
    "route": "startAppointmentEncounter",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "StartAppointmentEncounterCommand",
        "requestProtoFullName": "api.v1.omniwound_core.StartAppointmentEncounterCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "appointments.startAppointmentEncounter",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.start-appointment-encounter",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-coverages",
    "surface": "clinician",
    "route": "listCoverages",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListCoveragesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListCoveragesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "coverages.listCoverages",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-coverages",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-payor-organizations",
    "surface": "clinician",
    "route": "listPayorOrganizations",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListPayorOrganizationsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListPayorOrganizationsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "coverages.listPayorOrganizations",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-payor-organizations",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.add-payor",
    "surface": "clinician",
    "route": "addPayor",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "AddPayorCommand",
        "requestProtoFullName": "api.v1.omniwound_core.AddPayorCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "coverages.addPayor",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.add-payor",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-coverages",
    "surface": "clinician",
    "route": "updateCoverages",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateCoveragesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateCoveragesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "coverages.updateCoverages",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-coverages",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-patient-documents",
    "surface": "clinician",
    "route": "getPatientDocuments",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetPatientDocumentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetPatientDocumentsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "documents.getPatientDocuments",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-patient-documents",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-document-download-url",
    "surface": "clinician",
    "route": "getDocumentDownloadUrl",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetPatientDocumentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetPatientDocumentsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      },
      {
        "service": "object-storage",
        "method": "PresignGetObject",
        "requestProtoFullName": "omniwound.bff.v1.PresignGetObjectRequest",
        "binder": "canonical-json-envelope"
      }
    ],
    "target": {
      "extractorId": "documents.getDocumentDownloadUrl",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-document-download-url",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-field-templates",
    "surface": "clinician",
    "route": "listFieldTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListFieldTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListFieldTemplatesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.listFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-field-templates",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.save-field-templates",
    "surface": "clinician",
    "route": "saveFieldTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveFieldTemplatesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveFieldTemplatesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.saveFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.save-field-templates",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-org-field-templates",
    "surface": "clinician",
    "route": "listOrgFieldTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrgFieldTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrgFieldTemplatesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.listOrgFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-org-field-templates",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-org-field-template-counts",
    "surface": "clinician",
    "route": "listOrgFieldTemplateCounts",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrgFieldTemplateCountsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrgFieldTemplateCountsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.listOrgFieldTemplateCounts",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-org-field-template-counts",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.adopt-org-field-templates",
    "surface": "clinician",
    "route": "adoptOrgFieldTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrgFieldTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrgFieldTemplatesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "ListFieldTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListFieldTemplatesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "SaveFieldTemplatesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveFieldTemplatesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.adoptOrgFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.adopt-org-field-templates",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.save-org-field-templates",
    "surface": "clinician",
    "route": "saveOrgFieldTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveOrgFieldTemplatesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveOrgFieldTemplatesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "fieldTemplates.saveOrgFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.save-org-field-templates",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.geocode-address",
    "surface": "clinician",
    "route": "geocodeAddress",
    "downstreamMethods": [
      {
        "service": "geocoder",
        "method": "GET/search",
        "requestProtoFullName": "omniwound.bff.v1.GeocoderSearchRequest",
        "binder": "canonical-json-envelope"
      }
    ],
    "target": {
      "extractorId": "geocoding.geocodeAddress",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.geocode-address",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "not-applicable",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-medical-history",
    "surface": "clinician",
    "route": "getMedicalHistory",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetMedicalHistoryQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetMedicalHistoryQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "medicalHistory.getMedicalHistory",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-medical-history",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-medical-history",
    "surface": "clinician",
    "route": "updateMedicalHistory",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateMedicalHistoryCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateMedicalHistoryCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "medicalHistory.updateMedicalHistory",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-medical-history",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-medical-history-templates",
    "surface": "clinician",
    "route": "getMedicalHistoryTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetMedicalHistoryTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetMedicalHistoryTemplatesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "medicalHistoryTemplates.getMedicalHistoryTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-medical-history-templates",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-medical-history-templates",
    "surface": "clinician",
    "route": "updateMedicalHistoryTemplates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateMedicalHistoryTemplatesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateMedicalHistoryTemplatesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "medicalHistoryTemplates.updateMedicalHistoryTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-medical-history-templates",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-patients",
    "surface": "clinician",
    "route": "listPatients",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListCensusPatientsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListCensusPatientsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.listPatients",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-patients",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-patient-census-stats",
    "surface": "clinician",
    "route": "getPatientCensusStats",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetPatientCensusStatsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetPatientCensusStatsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.getPatientCensusStats",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-patient-census-stats",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-patient",
    "surface": "clinician",
    "route": "getPatient",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetPatientQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetPatientQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.getPatient",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-patient",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.check-duplicate-patient",
    "surface": "clinician",
    "route": "checkDuplicatePatient",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CheckDuplicatePatientQuery",
        "requestProtoFullName": "api.v1.omniwound_core.CheckDuplicatePatientQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.checkDuplicatePatient",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.check-duplicate-patient",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-organizations",
    "surface": "clinician",
    "route": "listOrganizations",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrganizationsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrganizationsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.listOrganizations",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-organizations",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-providers",
    "surface": "clinician",
    "route": "listProviders",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListProvidersQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListProvidersQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.listProviders",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-providers",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.create-patient",
    "surface": "clinician",
    "route": "createPatient",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CreatePatientCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CreatePatientCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.createPatient",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.create-patient",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.create-intake-patient",
    "surface": "clinician",
    "route": "createIntakePatient",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CreateIntakePatientCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CreateIntakePatientCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "patients.createIntakePatient",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.create-intake-patient",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-patient-profile",
    "surface": "clinician",
    "route": "updatePatientProfile",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdatePatientCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdatePatientCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "patients.updatePatientProfile",
      "selectors": [
        {
          "path": "patientId",
          "kind": "patient"
        },
        {
          "path": "id",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-patient-profile",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-progress-note",
    "surface": "clinician",
    "route": "getProgressNote",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetProgressNoteQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetProgressNoteQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "progressNotes.getProgressNote",
      "selectors": [
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-progress-note",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-progress-note-artifact-content",
    "surface": "clinician",
    "route": "getProgressNoteArtifactContent",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetProgressNoteArtifactContentQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetProgressNoteArtifactContentQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.getProgressNoteArtifactContent",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-progress-note-artifact-content",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-progress-note-pdf-download-url",
    "surface": "clinician",
    "route": "getProgressNotePdfDownloadUrl",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetProgressNoteArtifactQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetProgressNoteArtifactQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      },
      {
        "service": "object-storage",
        "method": "PresignGetObject",
        "requestProtoFullName": "omniwound.bff.v1.PresignGetObjectRequest",
        "binder": "canonical-json-envelope",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "progressNotes.getProgressNotePdfDownloadUrl",
      "selectors": [
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-progress-note-pdf-download-url",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-patient-progress-notes",
    "surface": "clinician",
    "route": "listPatientProgressNotes",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListPatientProgressNotesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListPatientProgressNotesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.listPatientProgressNotes",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-patient-progress-notes",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-progress-notes",
    "surface": "clinician",
    "route": "listProgressNotes",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListProgressNotesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListProgressNotesQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.listProgressNotes",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-progress-notes",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-progress-note-next-visit-availability",
    "surface": "clinician",
    "route": "listProgressNoteNextVisitAvailability",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListProgressNoteNextVisitAvailabilityQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListProgressNoteNextVisitAvailabilityQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "progressNotes.listProgressNoteNextVisitAvailability",
      "selectors": [
        {
          "path": "encounterId",
          "kind": "appointment"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-progress-note-next-visit-availability",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-note-originated-booking-reconciliation",
    "surface": "clinician",
    "route": "listNoteOriginatedBookingReconciliation",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListNoteOriginatedBookingReconciliationQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListNoteOriginatedBookingReconciliationQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.listNoteOriginatedBookingReconciliation",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-note-originated-booking-reconciliation",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.prepare-progress-note-signing-review",
    "surface": "clinician",
    "route": "prepareProgressNoteSigningReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PrepareProgressNoteSigningReviewCommand",
        "requestProtoFullName": "api.v1.omniwound_core.PrepareProgressNoteSigningReviewCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.prepareProgressNoteSigningReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.prepare-progress-note-signing-review",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.save-progress-note-step",
    "surface": "clinician",
    "route": "saveProgressNoteStep",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveProgressNoteStepCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveProgressNoteStepCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.saveProgressNoteStep",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.save-progress-note-step",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 41943040,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.save-progress-note-next-visit",
    "surface": "clinician",
    "route": "saveProgressNoteNextVisit",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveProgressNoteNextVisitCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveProgressNoteNextVisitCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "progressNotes.saveProgressNoteNextVisit",
      "selectors": [
        {
          "path": "save.encounterId",
          "kind": "appointment"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.save-progress-note-next-visit",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 41943040,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.start-or-resume-progress-note",
    "surface": "clinician",
    "route": "startOrResumeProgressNote",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "StartOrResumeProgressNoteCommand",
        "requestProtoFullName": "api.v1.omniwound_core.StartOrResumeProgressNoteCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.startOrResumeProgressNote",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.start-or-resume-progress-note",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.sign-progress-note",
    "surface": "clinician",
    "route": "signProgressNote",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SignProgressNoteCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SignProgressNoteCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.signProgressNote",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.sign-progress-note",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.save-amendment-step",
    "surface": "clinician",
    "route": "saveAmendmentStep",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveAmendmentStepCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveAmendmentStepCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.saveAmendmentStep",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.save-amendment-step",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.prepare-amendment-review",
    "surface": "clinician",
    "route": "prepareAmendmentReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PrepareAmendmentReviewCommand",
        "requestProtoFullName": "api.v1.omniwound_core.PrepareAmendmentReviewCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "progressNotes.prepareAmendmentReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.prepare-amendment-review",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.assign-qa-review",
    "surface": "clinician",
    "route": "assignQaReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "AssignQAReviewCommand",
        "requestProtoFullName": "api.v1.omniwound_core.AssignQAReviewCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.assignQaReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.assign-qa-review",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.takeover-qa-review",
    "surface": "clinician",
    "route": "takeoverQaReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "TakeoverQAReviewCommand",
        "requestProtoFullName": "api.v1.omniwound_core.TakeoverQAReviewCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.takeoverQaReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.takeover-qa-review",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.start-correction",
    "surface": "clinician",
    "route": "startCorrection",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "StartCorrectionCommand",
        "requestProtoFullName": "api.v1.omniwound_core.StartCorrectionCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.startCorrection",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.start-correction",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.review-and-finalize-correction",
    "surface": "clinician",
    "route": "reviewAndFinalizeCorrection",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ReviewAndFinalizeCorrectionCommand",
        "requestProtoFullName": "api.v1.omniwound_core.ReviewAndFinalizeCorrectionCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.reviewAndFinalizeCorrection",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.review-and-finalize-correction",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.prepare-clean-qa-approval",
    "surface": "clinician",
    "route": "prepareCleanQaApproval",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PrepareCleanQAApprovalCommand",
        "requestProtoFullName": "api.v1.omniwound_core.PrepareCleanQAApprovalCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.prepareCleanQaApproval",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.prepare-clean-qa-approval",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.approve-qa-review",
    "surface": "clinician",
    "route": "approveQaReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ApproveQAReviewCommand",
        "requestProtoFullName": "api.v1.omniwound_core.ApproveQAReviewCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.approveQaReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.approve-qa-review",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-qa-reviews",
    "surface": "clinician",
    "route": "listQaReviews",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListQAReviewsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListQAReviewsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.listQaReviews",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-qa-reviews",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-qa-review",
    "surface": "clinician",
    "route": "getQaReview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetQAReviewQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetQAReviewQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.getQaReview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-qa-review",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-qa-review-pdf-download-url",
    "surface": "clinician",
    "route": "getQaReviewPdfDownloadUrl",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetProgressNoteArtifactQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetProgressNoteArtifactQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      },
      {
        "service": "object-storage",
        "method": "PresignGetObject",
        "requestProtoFullName": "omniwound.bff.v1.PresignGetObjectRequest",
        "binder": "canonical-json-envelope"
      }
    ],
    "target": {
      "extractorId": "qa.getQaReviewPdfDownloadUrl",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-qa-review-pdf-download-url",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-qa-review-pdf-content",
    "surface": "clinician",
    "route": "getQaReviewPdfContent",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetProgressNoteArtifactContentQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetProgressNoteArtifactContentQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.getQaReviewPdfContent",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "documentReferenceId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-qa-review-pdf-content",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-correction-difference",
    "surface": "clinician",
    "route": "getCorrectionDifference",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetCorrectionDifferenceQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetCorrectionDifferenceQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.getCorrectionDifference",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-correction-difference",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-correction-preview",
    "surface": "clinician",
    "route": "getCorrectionPreview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetCorrectionPreviewQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetCorrectionPreviewQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "qa.getCorrectionPreview",
      "selectors": [
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "qaReviewId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-correction-preview",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-referrals",
    "surface": "clinician",
    "route": "listReferrals",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListReferralsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListReferralsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "referrals.listReferrals",
      "selectors": [
        {
          "path": "referralId",
          "kind": "referral"
        },
        {
          "path": "serviceRequestId",
          "kind": "referral"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-referrals",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-referral",
    "surface": "clinician",
    "route": "updateReferral",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateReferralCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateReferralCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson",
        "targetSource": "action"
      }
    ],
    "target": {
      "extractorId": "referrals.updateReferral",
      "selectors": [
        {
          "path": "referralId",
          "kind": "referral"
        },
        {
          "path": "serviceRequestId",
          "kind": "referral"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-referral",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-referral-readiness",
    "surface": "clinician",
    "route": "getReferralReadiness",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetReferralReadinessQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetReferralReadinessQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "referrals.getReferralReadiness",
      "selectors": [
        {
          "path": "referralId",
          "kind": "referral"
        },
        {
          "path": "serviceRequestId",
          "kind": "referral"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-referral-readiness",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.suggest-providers-for-referral",
    "surface": "clinician",
    "route": "suggestProvidersForReferral",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetReferralQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetReferralQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "EnsureReferralServiceLocationCommand",
        "requestProtoFullName": "api.v1.omniwound_core.EnsureReferralServiceLocationCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "care-dispatcher",
        "method": "SuggestProvidersQuery",
        "requestProtoFullName": "api.v1.care_dispatcher.SuggestProvidersQuery",
        "binder": "generated-protojson",
        "organizationIdSemantics": "fhir-reference"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "referrals.suggestProvidersForReferral",
      "selectors": [
        {
          "path": "referralId",
          "kind": "referral"
        },
        {
          "path": "serviceRequestId",
          "kind": "referral"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.suggest-providers-for-referral",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-skin-exam-catalog",
    "surface": "clinician",
    "route": "getSkinExamCatalog",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetSkinExamCatalogQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetSkinExamCatalogQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "skinExamTerminology.getSkinExamCatalog",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-skin-exam-catalog",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-skin-exam-locations",
    "surface": "clinician",
    "route": "listSkinExamLocations",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListSkinExamLocationsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListSkinExamLocationsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "skinExamTerminology.listSkinExamLocations",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-skin-exam-locations",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-skin-exam-etiology-options",
    "surface": "clinician",
    "route": "listSkinExamEtiologyOptions",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListSkinExamEtiologyOptionsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListSkinExamEtiologyOptionsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "skinExamTerminology.listSkinExamEtiologyOptions",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-skin-exam-etiology-options",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.list-visits",
    "surface": "clinician",
    "route": "listVisits",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListVisitsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListVisitsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "ListAppointmentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListAppointmentsQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "visits.listVisits",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "visitId",
          "kind": "appointment"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.list-visits",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.update-visit",
    "surface": "clinician",
    "route": "updateVisit",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateVisitCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateVisitCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "visits.updateVisit",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "visitId",
          "kind": "appointment"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.update-visit",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.correct-encounter-timing",
    "surface": "clinician",
    "route": "correctEncounterTiming",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CorrectEncounterTimingCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CorrectEncounterTimingCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "visits.correctEncounterTiming",
      "selectors": [
        {
          "path": "visitId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "appointmentId",
          "kind": "appointment"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "selection": "ordered-fallback",
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.correct-encounter-timing",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.cancel-visit",
    "surface": "clinician",
    "route": "cancelVisit",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CancelVisitCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CancelVisitCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "visits.cancelVisit",
      "selectors": [
        {
          "path": "appointmentId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "visitId",
          "kind": "appointment"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.cancel-visit",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.set-visit-seen-status",
    "surface": "clinician",
    "route": "setVisitSeenStatus",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "RecordVisitAttendanceOutcomeCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordVisitAttendanceOutcomeCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "visits.setVisitSeenStatus",
      "selectors": [
        {
          "path": "visitId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        },
        {
          "path": "appointmentId",
          "kind": "appointment"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "selection": "ordered-fallback",
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.set-visit-seen-status",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.reserve-wound-image-upload",
    "surface": "clinician",
    "route": "reserveWoundImageUpload",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ReserveWoundImageUploadCommand",
        "requestProtoFullName": "api.v1.omniwound_core.ReserveWoundImageUploadCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.reserveWoundImageUpload",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.reserve-wound-image-upload",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.upload-wound-image-bytes",
    "surface": "clinician",
    "route": "uploadWoundImageBytes",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UploadWoundImageBytesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UploadWoundImageBytesCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.uploadWoundImageBytes",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.upload-wound-image-bytes",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 41943040,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.complete-wound-image-upload",
    "surface": "clinician",
    "route": "completeWoundImageUpload",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CompleteWoundImageUploadCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CompleteWoundImageUploadCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.completeWoundImageUpload",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.complete-wound-image-upload",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.prepare-wound-image-terminal-release",
    "surface": "clinician",
    "route": "prepareWoundImageTerminalRelease",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PrepareWoundImageTerminalReleaseCommand",
        "requestProtoFullName": "api.v1.omniwound_core.PrepareWoundImageTerminalReleaseCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.prepareWoundImageTerminalRelease",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.prepare-wound-image-terminal-release",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.restore-wound-image-release",
    "surface": "clinician",
    "route": "restoreWoundImageRelease",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "RestoreWoundImageReleaseCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RestoreWoundImageReleaseCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.restoreWoundImageRelease",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.restore-wound-image-release",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.preview-wound-image",
    "surface": "clinician",
    "route": "previewWoundImage",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PreviewWoundImageQuery",
        "requestProtoFullName": "api.v1.omniwound_core.PreviewWoundImageQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.previewWoundImage",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        },
        {
          "path": "woundImageId",
          "kind": "progress-note"
        },
        {
          "path": "progressNoteId",
          "kind": "progress-note"
        },
        {
          "path": "patientId",
          "kind": "patient"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.preview-wound-image",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.clinician.get-signed-wound-image-media-content-url",
    "surface": "clinician",
    "route": "getSignedWoundImageMediaContentUrl",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GetSignedWoundImageMediaContentQuery",
        "requestProtoFullName": "api.v1.omniwound_core.GetSignedWoundImageMediaContentQuery",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "RecordAuditEventCommand",
        "requestProtoFullName": "api.v1.omniwound_core.RecordAuditEventCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "woundImages.getSignedWoundImageMediaContentUrl",
      "selectors": [
        {
          "path": "mediaId",
          "kind": "progress-note"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.clinician.get-signed-wound-image-media-content-url",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.get-administrative-access",
    "surface": "admin",
    "route": "GET /api/v1/access/me",
    "downstreamMethods": [],
    "target": {
      "extractorId": "admin.getAdministrativeAccess",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.get-administrative-access",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "not-applicable",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.list-accounts",
    "surface": "admin",
    "route": "GET /api/v1/accounts/users",
    "downstreamMethods": [
      {
        "service": "keycloak-admin",
        "method": "users.find",
        "requestProtoFullName": "omniwound.keycloak_admin.v1.UsersFindRequest",
        "binder": "canonical-json-envelope"
      },
      {
        "service": "keycloak-admin",
        "method": "users.listRealmRoleMappings",
        "requestProtoFullName": "omniwound.keycloak_admin.v1.UsersListRealmRoleMappingsRequest",
        "binder": "canonical-json-envelope"
      },
      {
        "service": "omniwound-core",
        "method": "ResolvePractitionerDisplayNamesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ResolvePractitionerDisplayNamesQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.listAccounts",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.list-accounts",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.create-account",
    "surface": "admin",
    "route": "POST /api/v1/accounts/users",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ProvisionProviderAccountCommand",
        "requestProtoFullName": "api.v1.omniwound_core.ProvisionProviderAccountCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      },
      {
        "service": "keycloak-admin",
        "method": "users.resetPassword",
        "requestProtoFullName": "omniwound.keycloak_admin.v1.UsersResetPasswordRequest",
        "binder": "canonical-json-envelope"
      }
    ],
    "target": {
      "extractorId": "admin.createAccount",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.create-account",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.change-account-role",
    "surface": "admin",
    "route": "PUT /api/v1/accounts/users/:userId/realm-role",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.changeAccountRole",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "keycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.change-account-role",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.change-account-enabled-state",
    "surface": "admin",
    "route": "PATCH /api/v1/accounts/users/:userId/enabled",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.changeAccountEnabledState",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "keycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.change-account-enabled-state",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.bind-practitioner",
    "surface": "admin",
    "route": "PUT /api/v1/accounts/users/:userId/practitioner-link",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.bindPractitioner",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "keycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.bind-practitioner",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.clear-practitioner-binding",
    "surface": "admin",
    "route": "POST /api/v1/accounts/users/:userId/practitioner-link/clear",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.clearPractitionerBinding",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "keycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.clear-practitioner-binding",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.restore-account-credential",
    "surface": "admin",
    "route": "POST /api/v1/accounts/users/:userId/credential-restore",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.restoreAccountCredential",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "keycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.restore-account-credential",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.self-contain-account",
    "surface": "admin",
    "route": "POST /api/v1/accounts/self/contain",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CoordinateAccountLifecycleCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CoordinateAccountLifecycleCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.selfContainAccount",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.self-contain-account",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.get-provider-signature",
    "surface": "admin",
    "route": "GET /api/v1/providers/:fhirPractitionerId/signature",
    "downstreamMethods": [
      {
        "service": "object-storage",
        "method": "PresignGetObject",
        "requestProtoFullName": "omniwound.admin.bff.v1.PresignGetObjectRequest",
        "binder": "canonical-json-envelope"
      }
    ],
    "target": {
      "extractorId": "admin.getProviderSignature",
      "selectors": [
        {
          "path": "params.fhirPractitionerId",
          "kind": "provider"
        },
        {
          "path": "fhirPractitionerId",
          "kind": "provider"
        }
      ],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.get-provider-signature",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "not-applicable",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.reassign-visit-provider",
    "surface": "admin",
    "route": "PATCH /api/v1/visits/:encounterId/provider",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "UpdateVisitCommand",
        "requestProtoFullName": "api.v1.omniwound_core.UpdateVisitCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.reassignVisitProvider",
      "selectors": [
        {
          "path": "params.encounterId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.reassign-visit-provider",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.correct-visit-timing",
    "surface": "admin",
    "route": "PATCH /api/v1/visits/:encounterId/timing",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "CorrectEncounterTimingCommand",
        "requestProtoFullName": "api.v1.omniwound_core.CorrectEncounterTimingCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.correctVisitTiming",
      "selectors": [
        {
          "path": "params.encounterId",
          "kind": "appointment"
        },
        {
          "path": "encounterId",
          "kind": "appointment"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.correct-visit-timing",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.list-staff-access-assignments",
    "surface": "admin",
    "route": "GET /api/v1/accounts/users/:userId/access-assignments",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListStaffAccessAssignmentsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListStaffAccessAssignmentsQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.listStaffAccessAssignments",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "targetKeycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.list-staff-access-assignments",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.preview-staff-access-assignment-grant",
    "surface": "admin",
    "route": "POST /api/v1/accounts/users/:userId/access-assignments/preview",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "PreviewGrantStaffAccessAssignmentQuery",
        "requestProtoFullName": "api.v1.omniwound_core.PreviewGrantStaffAccessAssignmentQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.previewStaffAccessAssignmentGrant",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "targetKeycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.preview-staff-access-assignment-grant",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.grant-staff-access-assignment",
    "surface": "admin",
    "route": "POST /api/v1/accounts/users/:userId/access-assignments",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "GrantStaffAccessAssignmentCommand",
        "requestProtoFullName": "api.v1.omniwound_core.GrantStaffAccessAssignmentCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.grantStaffAccessAssignment",
      "selectors": [
        {
          "path": "params.userId",
          "kind": "staff-account"
        },
        {
          "path": "targetKeycloakUserId",
          "kind": "staff-account"
        }
      ],
      "required": true,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.grant-staff-access-assignment",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.list-organization-field-templates",
    "surface": "admin",
    "route": "GET /api/v1/org-field-templates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrgFieldTemplatesQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrgFieldTemplatesQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.listOrganizationFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.list-organization-field-templates",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.list-organization-field-template-counts",
    "surface": "admin",
    "route": "GET /api/v1/org-field-templates/counts",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "ListOrgFieldTemplateCountsQuery",
        "requestProtoFullName": "api.v1.omniwound_core.ListOrgFieldTemplateCountsQuery",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.listOrganizationFieldTemplateCounts",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.list-organization-field-template-counts",
    "effect": "read-only",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  },
  {
    "id": "omniwound.admin.save-organization-field-templates",
    "surface": "admin",
    "route": "PUT /api/v1/org-field-templates",
    "downstreamMethods": [
      {
        "service": "omniwound-core",
        "method": "SaveOrgFieldTemplatesCommand",
        "requestProtoFullName": "api.v1.omniwound_core.SaveOrgFieldTemplatesCommand",
        "binder": "generated-protojson"
      }
    ],
    "target": {
      "extractorId": "admin.saveOrganizationFieldTemplates",
      "selectors": [],
      "required": false,
      "allowedAncestorKeys": [
        "organizationId"
      ]
    },
    "policyKey": "omniwound.admin.save-organization-field-templates",
    "effect": "mutation",
    "authorityMode": "human-or-assignment-backed",
    "maxPayloadBytes": 1048576,
    "asyncClass": "synchronous",
    "allowedCaller": "interactive-human",
    "receiptRequirement": "required-for-core",
    "rollout": "enforce"
  }
] as const;

export type InteractiveOperation = (typeof INTERACTIVE_OPERATION_REGISTRY)[number];
export type InteractiveOperationId = InteractiveOperation['id'];

export function interactiveOperation(operationId: InteractiveOperationId): InteractiveOperation {
  const operation = INTERACTIVE_OPERATION_REGISTRY.find((candidate) => candidate.id === operationId);
  if (!operation) throw new Error(`Unregistered interactive operation: ${operationId}`);
  return operation;
}

export function clinicianOperationId(route: string): InteractiveOperationId {
  const operation = INTERACTIVE_OPERATION_REGISTRY.find(
    (candidate) => candidate.surface === 'clinician' && candidate.route === route,
  );
  if (!operation) throw new Error(`Unregistered clinician operation: ${route}`);
  return operation.id;
}

export function adminOperationId(method: string, routePath: string): InteractiveOperationId {
  const route = `${method.toUpperCase()} ${routePath}`;
  const operation = INTERACTIVE_OPERATION_REGISTRY.find(
    (candidate) => candidate.surface === 'admin' && candidate.route === route,
  );
  if (!operation) throw new Error(`Unregistered admin operation: ${route}`);
  return operation.id;
}
